/**
 * 主子表表单联动
 *
 * 1. 联动隐藏/显示，元数据按照主表的配，子表字段不能与主表相同，不然区分不出是对子表的操作
 *    eg. 客户订单单对象 - 发票类型=999 - 隐藏子表(商品信息)的'销售价'
 */

import ST_C_INITIAL_SHARE_ITEM from './standardTable/details/ST_C_INITIAL_SHARE_ITEM'
import SG_C_PRE_SALE_PLAN_ITEM from './standardTable/details/SG_C_PRE_SALE_PLAN_ITEM'
import ST_C_EXPRESS_PRICE_STRATEGY_ITEM from './standardTable/details/ST_C_EXPRESS_PRICE_STRATEGY_ITEM'

export default () => ({
  mixins: [
    ST_C_EXPRESS_PRICE_STRATEGY_ITEM,
    SG_C_PRE_SALE_PLAN_ITEM,
    ST_C_INITIAL_SHARE_ITEM,
  ],
  data() {
    return {}
  },
  watch: {},
  created() { },
  updated() { },
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail }) => {
      console.log('notificationOfMain::', detail.item.colname);
      if (detail.hasOwnProperty('INVOICE_TYPE')) {
        switch (detail.INVOICE_TYPE) {
          case 999:
            const page = vm.$store.state[R3.getModuleName()]
            const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
            nowTabForm.forEach((it, dex) => {
              if (it.colname == "PRICE_SALE") {
                it.show = false
              }
            });
            // this.updateFormDataForRefTable(nowTabForm);
            const newData = {
              tabIndex: page.tabCurrentIndex,
              inpubobj: nowTabForm
            }
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData)
            break;
          default:
            break;
        }
      }
    }, false);
  },
  methods: {
    /* ...mapMutations(R3.getModuleName(), [
      'updateFormDataForRefTable'
    ]) */
  },
})
